import { useEffect } from 'react';
import axios from 'axios';
import EVENTS from '@/utils/Constants/Events';
import { useWishlistContext } from '@/account/context/wishlist';

export default ({ sharedLink = null, type = null } = {}) => {
  const [
    ,
    {
      setWishlistUid,
      setWishlistEntries,
      setWishlistEntriesLoading,
      unsetWishlistEntriesLoading,
    },
  ] = useWishlistContext();

  const fetchSuccess = data => {
    if (data.uid) {
      setWishlistUid(data.uid);
    }
    if (data.entryList) {
      setWishlistEntries(data.entryList);
    }
    unsetWishlistEntriesLoading();
  };

  useEffect(() => {
    const source = axios.CancelToken.source();
    DLG.EVE.on(EVENTS.WISHLIST.REFRESH, fetchSuccess);
    setWishlistEntriesLoading();
    DLG.EVE.emit(EVENTS.WISHLIST.GET, {
      config: { cancelToken: source.token },
      type,
      sharedLink,
    });
    return () => {
      DLG.EVE.off(EVENTS.WISHLIST.REFRESH, fetchSuccess);
      source.cancel();
    };
  }, []);
};
